var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h3',{class:['footer-logo', {'footer-logo_disabled': _vm.isHPTransitionDisabled}]},[(_vm.isHPTransitionDisabled)?_c('span',{staticClass:"footer-logo__link"}):_c('a',{staticClass:"footer-logo__link",attrs:{"href":"/"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }